import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectEffectiveValues } from '@hkm/components/Menu/PropertySelector/domain/selectors';
import { GuestServiceStatusType } from '@hkm/shared/enum/guestServiceStatusType';
import { useGuestServiceMap } from '@hkm/shared/hooks/useGuestServiceMap';

import { DictionaryEntity } from '@ac/library-api';

export function useEnabledGuestServiceStatuses(
  excludeStatus?: GuestServiceStatusType[]
): DictionaryEntity[] {
  const { t } = useTranslation();
  const enabledStatuses = useGuestServiceMap();
  const effectiveValues = useSelector(selectEffectiveValues)!;

  return useMemo(() => {
    if (!effectiveValues.guestServiceStatuses) {
      return [];
    }

    return Array.from(enabledStatuses.keys())
      .filter((status: GuestServiceStatusType) => {
        const exclude = excludeStatus || [];

        return !exclude.includes(status);
      })
      .map((status: GuestServiceStatusType) => {
        return enabledStatuses.get(status)
          ? {
              code: status,
              name: t(`GLOBAL.GUEST_SERVICE_STATUS.VALUES.${status}`)
            }
          : false;
      })
      .filter(Boolean) as DictionaryEntity[];
  }, [effectiveValues]);
}



// WEBPACK FOOTER //
// ./src/shared/hooks/useEnabledGuestServiceStatuses.ts